// @mui material components
import Card from '@mui/material/Card'

// Soft UI Dashboard React components
import { useAlert } from 'react-alert'
import ModeEditIcon from '@mui/icons-material/Edit'
import axios from 'axios'
import React, { useEffect, useReducer, useState, Fragment, useRef } from 'react'
import { Box, Button, Container, Stack, SvgIcon, Typography, Grid, Snackbar, Checkbox, Paper, NativeSelect, TextField, Dialog, DialogActions, DialogContent, DialogContentText, InputLabel, } from '@mui/material';
import { FileUploader } from "react-drag-drop-files";
import ReactSelect from 'react-select'
import LoadingButton from '@mui/lab/LoadingButton'
import { Input } from '@mui/material'
import DialogTitle from '@mui/material/DialogTitle';
import Headroom from "react-headroom";
import CircularProgress from '@mui/material/CircularProgress'
import { Controller, useForm } from 'react-hook-form'
import TextareaAutosize from '@mui/material/TextareaAutosize'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
// import PlusIcon from '@heroicons/react/24/solid/PlusIcon';
import AddIcon from '@mui/icons-material/Add';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import Download from '@mui/icons-material/Download'
import { TabPanel, TabContext, TabList } from '@mui/lab'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import PermIdentity from '@mui/icons-material/PermIdentity'
import WorkOutline from '@mui/icons-material/WorkOutline'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import { DataGrid } from '@mui/x-data-grid';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
// import Avatar from 'react-avatar'
import Avatar from '@mui/material/Avatar';
import fileDownload from 'js-file-download';
import Tooltip from '@mui/material/Tooltip';
import Moment from 'moment';
import { confirmAlert } from 'react-confirm-alert' // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined'
import DeleteIcon from '@mui/icons-material/Delete'
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EducationRegistration from './EducationRegistration'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import SignInIcon from '@mui/icons-material/PersonAdd';
const Documents = (props) => {
  document.title = "Documents | Maevisory";
  const token = localStorage.getItem('Token')
  const auth = `Bearer ${token}`
  const headers = {
    Authorization: auth
  }
  const alert = useAlert()
  const [docslist, setdocslist] = useState([])
  const [refresh, setRefresh] = useState(false)
  const [open, setOpen] = React.useState(false)
  const [docError, setdocError] = useState(false)
  const [DateError, setDateError] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [date, setdate] = useState('')
  const [base64, setbase64] = useState('')
  const userid = localStorage.getItem('userid')
  const UserName = localStorage.getItem('UserName')

  const [patientId, setpatientId] = useState(userid)
  const [columnID, setcolumnID] = useState(props.columnID !== undefined ? props.columnID : 0)
  const type = localStorage.getItem('User_Type')
  const [doctype, setdocType] = useState("")
  const [opendocs, setopendocs] = useState(false)
  const [urlFile, seturlFile] = useState('')
  const [urldownload, seturldownload] = useState('')
  const [DocName, setDocName] = useState('')
  const [FullDocName, setFullDocName] = useState('')
  const [spinner, setSpinner] = useState(false)
  const [file, setFile] = useState(null)
  const [filename, setfilename] = useState([])
  const [base64Data, setBase64Data] = useState([])
  const [totalProgress, setTotalProgress] = React.useState(0)
  const [savedFiles, setSavedFiles] = React.useState([])

  const fields = [
    'id',
    'documentName',
    'fileUrl',
    'patientId',
    'practiceId',
    'deleted',
    'date',
    'createdBy',
    'clientCreatedDate',
    'updatedBy',
    'clientUpdatedDate',
    'createdDate',
    'updatedDate',
    'base64',
    'authId',
    'type',
    'documentType',
    'checkvisibel',
    "content",
    "name",
    "therapistId",
    "templateId",
    "pending",
    "approve",
    "approveDate",
    "approveBy",
    "superviseeSign",
    "signDate",
  ]
  const defValues = {
    id: 0,
    documentName: '',
    fileUrl: '',
    patientId: 0,
    practiceId: '',
    date: '',
    createdBy: '',
    Deleted: false,
    clientCreatedDate: '',
    updatedBy: '',
    clientUpdatedDate: '',
    createdDate: '',
    updatedDate: '',
    base64: '',
    authId: columnID,
    type: type,
    documentType: '',
    checkvisibel: '',
    content: '',
    name: '',
    therapistId:'',
    templateId:'',
    pending:'',
    approve:'',
    approveDate:'',
    approveBy:'',
    superviseeSign:'',
    signDate:'',

  }

  const appointmentDocslist = [
    {
      field: 'documentName',
      headerName: 'Document Name',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 1,
      renderCell: cellValues => (
        <>
          <Tooltip title={`${cellValues.value}`} placement='left'>
            <div>
              <Button
                onClick={() => {
                  setopendocs(true)
                  var url = cellValues.row.fileUrl
                  seturldownload(cellValues.row.fileUrl)
                  // seturlFile(`${process.env.REACT_APP_Document_URL}/${url}`)
                  axios
                    .get(`${process.env.REACT_APP_API_URL}/UserDocument/ViewPatientDocument?path=${url}`, {
                      headers,
                    })
                    .then(response => {
                      seturlFile(response)
                    })
                    .catch(error => {
                      console.error('There was an error!', error)
                    })
                  var arr = cellValues.row.documentName.split('.')
                  setDocName(arr.length > 0 ? arr[1].toLowerCase() : '')
                  setFullDocName(cellValues.row.documentName)
                }}
              >{`${cellValues.value}`}</Button>
            </div>
          </Tooltip>
        </>
      )
    },
    {
      field: 'documentType',
      headerName: 'Type',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.5
    },
    {
      field: 'date',
      headerName: 'Document Date',
      sortable: true,
      headerClassName: 'super-app-theme--header',
      flex: 0.5
    },
    // {
    //   field: 'deleted',
    //   headerName: 'Delete',
    //   sortable: true,
    //   headerClassName: 'super-app-theme--header',
    //   minWidth: 0.5,
    //   renderCell: cell => (
    //     <DeleteIcon
    //       style={{
    //         marginRight: '5px',
    //         float: 'right',
    //         marginTop: '5px',
    //         color: 'red',
    //         cursor: 'pointer',
    //         zIndex: 250000,
    //       }}
    //       onClick={() => {
    //         Swal.fire({
    //           title: 'Do you want to delete the record?',
    //           text: 'This action cannot be undone.',
    //           icon: 'warning',
    //           showCancelButton: true,
    //           confirmButtonColor: '#d33',
    //           cancelButtonColor: '#3085d6',
    //           confirmButtonText: 'Yes',
    //           cancelButtonText: 'No',
    //           target: document.querySelector('#hello-world'),
    //         }).then((result) => {
    //           if (result.isConfirmed) {
    //             const postData = {
    //               documentName: cell.row.documentName,
    //               date: cell.row.date,
    //               id: cell.row.id,
    //               deleted: true,
    //             };

    //             axios
    //               .post(`${process.env.REACT_APP_API_URL}/UserDocument/userDocument`, postData, {
    //                 headers,
    //               })
    //               .then(response => {
    //                 setRefresh(!refresh);
    //                 Swal.fire(
    //                   {
    //                     title: 'Deleted',
    //                     text: 'Your file has been deleted.',
    //                     icon: 'success',
    //                     target: document.querySelector('#hello-world'),
    //                   }

    //                 );
    //                 // Handle any other actions after successful delete
    //               })
    //               .catch(error => {
    //                 console.error('There was an error!', error);
    //               });
    //           }
    //         });
    //       }}
    //     />
    //   ),
    // }
    {
      field: 'inActive',
      headerClassName: 'super-app-theme--header',
      headerName: 'Delete',
      sortable: true,
      flex: 0.14,
      renderCell: cellValues => (
        <DeleteIcon
          style={{
            marginRight: '5px',
            float: 'right',
            marginTop: '-1px',
            color: 'red',
            cursor: 'pointer'
          }}
          onClick={() => handleOpenModalDel(cellValues.row)}
        />
      )
    }

  ]
  const [Eduid, seteduid] = useState('')

  const columns = [
    {
      field: 'sponsorName',
      headerClassName: 'super-app-theme--header',
      headerName: 'Sponsor Name',
      cellClassName: 'gridCell',
      flex: 0.7,
      renderCell: cellValues => (
        <Button
          size='small'
          variant='text'
          color='info'
          onClick={(event) => {
            setEducation(true)
            seteduid(cellValues.row.id)
            // openIncidentRegistration(event,cellValues.row.id )
          }}
        >{`${cellValues.row.sponsorName}`}</Button>
      )
    },
    {
      field: 'course',
      headerClassName: 'super-app-theme--header',
      headerName: 'Course/Activity',
      flex: 0.5
    },
    {
      field: 'programTitle',
      headerClassName: 'super-app-theme--header',
      headerName: ' Program Title',
      flex: 0.5
    },

    {
      field: 'numberOfCes',
      headerClassName: 'super-app-theme--header',
      headerName: 'Number Of CES',
      flex: 0.5
    },
    {
      field: 'isActive',
      headerClassName: 'super-app-theme--header',
      headerName: 'Delete',
      sortable: true,
      flex: 0.1,
      renderCell: cell => (
        <DeleteIcon
          style={{
            marginRight: '5px',
            float: 'right',
            marginTop: '5px',
            color: 'red',
            cursor: 'pointer'
          }}
          onClick={cellValues => {
            confirmAlert({
              message: 'Do you want to delete the record.',
              closeOnEscape: true,
              closeOnClickOutside: true,
              overlayClassName: 'overlay-custom-class-name',
              buttons: [
                {
                  label: 'Yes',
                  onClick: () => {
                    const postData = {

                      inactive: true,
                      id: cell.row.id
                    }

                    axios
                      .post(`${process.env.REACT_APP_API_URL}/EducationDetails/addEducationDetails`, postData, {
                        headers
                      })
                      .then(response => {
                        setRefresh(!refresh)
                        // setOpenNote(false)
                        // console.log('response.data: ', response.data)
                      })
                      .catch(error => {
                        console.error('There was an error!', error)
                      })
                  }
                },
                {
                  label: 'No'
                }
              ]
            })
          }}
        ></DeleteIcon>
      )
    }


  ]
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);
  const handleOpenModalDel = (row) => {
    setDeleteRow(row);
    setDeleteAlert(true);
  };

  const handleCloseModal = () => {
    setDeleteAlert(false);
    setDeleteRow(null);

  };
  const handleDelete = () => {
    const postData = {
      documentName: deleteRow.documentName,
      date: deleteRow.date,
      id: deleteRow.id,
      deleted: true,
    };
    axios.post(`${process.env.REACT_APP_API_URL}/UserDocument/userDocument`, postData, { headers })
      .then(() => {
        setRefresh(!refresh);
        handleCloseModal();
      })
      .catch(error => {
        console.error('There was an error!', error);
        handleCloseModal();
      });
  };
  const {
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
    clearErrors,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    context: undefined,
    criteriaMode: 'firstError',
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    defaultValues: defValues
  })

  const handleOpenn = () => {
    setOpen(true)
    setSubmitting(false)
    setbase64('')
    setfilename('')
  }
  function applyRefresh() {
    setRefresh(!refresh)
  }
  const handleClose = () => {
    setopendocs(false)
    setFile(null)
    setOpen(false)
    setSubmitting(false)
    // setopenAppcreate(false)
    setRefresh(true)
  }
  useEffect(() => {
    setSpinner(true)
    axios
      .get(`${process.env.REACT_APP_API_URL}/UserDocument/userDocumentList?userId=${patientId}&type=${type} `, { headers })
      .then((response) => {
        fields.forEach(field => {
          setValue(field, response[field])
        })
        setSpinner(false)
        setdocslist(response)
        setdocType(response.documentType)
      })
      .catch(error => {
        setSpinner(false)
        console.error('There was an error!', error)
      })
  }, [refresh, columnID])

  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    background: 'drak',
    fontSize: '13.4px !important',
    color: 'drak !important',
    borderColor: '#326C1D',
    '& .MuiDataGrid-cell:hover': {
      color: 'rgba(5, 152, 236, 0.637) !important',
      fontSize: '14.6px !important',
    },
    '& .super-app-theme--header': {
      backgroundColor: '#377562',
      borderRadius: 0.1,
      color: 'white',
      fontSize: '16px !important',

    },

  }
  const styleofmodal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 950,
    // height: 500,
    bgcolor: 'background.paper',
    border: '2px solid #377562',
    boxShadow: 24,
    p: 4
  }
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700, // Increased width
    height: 400, // Fixed height
    bgcolor: 'background.paper',
    border: '2px solid #377562',
    boxShadow: 24,
    p: 4,
    overflowY: 'auto' // Enables vertical scrollbar
  };
  const style2 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1020, // Increased width
    height: 570, // Fixed height
    bgcolor: 'background.paper',
    border: '2px solid #377562',
    boxShadow: 24,
    p: 2,
    overflowY: 'auto' // Enables vertical scrollbar
  };
  const fileToBase64 = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })
  }
  const handleChangeforfile = async files => {
    const newFilenames = []
    const newBase64Data = []

    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      const base64 = await fileToBase64(file)
      newFilenames.push(file.name)
      newBase64Data.push(base64)
    }

    setfilename(newFilenames)
    setBase64Data(newBase64Data)
    setdocError(false)
  }
  const onSubmit = data => {
    if (base64Data.length <= 0) {
      setdocError(true)
      return
    }
    if (!date) {
      setDateError(true)
      return
    }

    setdocError(false)
    setSubmitting(true)
    setSavedFiles([])

    const postData = []
    let totalLength = 0
    for (let i = 0; i < base64Data.length; i++) {
      const documentData = {

        userId: patientId,
        // patientId:AutpattientID,
        date: date,
        documentName: filename[i],
        base64: base64Data[i],
        documentType: doctype,
        type: type,
        checkvisibel: data.checkvisibel
      }

      postData.push(documentData)
      totalLength += base64Data[i].length
    }

    const requests = postData.map((documentData, index) => {
      const config = {
        onUploadProgress: function (progressEvent) {
          const progress = Math.round((progressEvent.loaded / totalLength) * 1.5)
          if (progress <= 100) {
            setTotalProgress(progress)
          } else {
            setTotalProgress(100)
          }
        },
        headers
      }
      return axios
        .post(`${process.env.REACT_APP_API_URL}/UserDocument/userDocument`, documentData, config,)
        .then(response => {
          // Update the savedFiles state with the index of the saved file
          setSavedFiles(savedFiles => [...savedFiles, index])

          setSpinner(false)
          setOpen(false)
          setSubmitting(false)
          if (response) {
            // toast.success('Document uploaded successfully.', { 
            //   position: "top-center",
            //   hideProgressBar: false,
            //   closeOnClick: false,
            //   pauseOnHover: false,
            //   draggable: false,
            //   progress: undefined,
            //   theme: "light",
            alert.success('Document uploaded successfully.', {
              type: 'success',
              onClose: () => {
                // if (props.callingFrom == 'Patient') {
                //   props.updateHealthHistory(response.id, response.authId)
                //   console.log('checktype', response.authId)
                //   props.handleClose222()
                // }
                // else if (props.callingFrom == 'Patient1') {
                //   props.updateHealthHistory(response.id, response.authId)
                //   console.log('checktype', response.authId)
                //   props.handleClose()
                // }
                applyRefresh()

              }
            })
          }


          else {
            alert.error('Error uploading one or more documents.', {
              type: 'error'
            })
          }
        })
        .catch(error => {
          setSpinner(false)
          console.log(error)
          setSubmitting(false)
          toast.error(`Error ${error.message}`, {
            type: 'error'
          })
        })
    })


  }
  const handleDownloadPDF = (url, filename) => {
    setSpinner(true)
    setSubmitting(true)
    axios
      .get(`${process.env.REACT_APP_API_URL}/ProviderDocument/DownloadAWSFile?path=${url}`, {
        headers,
        responseType: 'blob',
      })
      .then((response) => {
        setopendocs(false)
        setSpinner(false)
        setSubmitting(false)
        const fileExtension = filename.split('.').pop().toLowerCase();
        const blobUrl = window.URL.createObjectURL(new Blob([response]));
        const fileName =
          fileExtension === 'pdf'
            ? 'file.pdf'
            : `image.${fileExtension}`; // Use dynamic naming for images
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', fileName); // Dynamically set the file name
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        console.error('There was an error!', error);
      });
  };
  const [value, setvalue] = React.useState(0);
  const handleChangetab = (event, newValue) => {
    setvalue(newValue);
  };
  const [Education, setEducation] = React.useState(false);
  const handleOpenEducation = () => setEducation(true);
  const handleCloseEducation = () => {
    setEducation(false)
    seteduid('')
  };
  const [rows, setRows] = useState(null)
  useEffect(() => {
    if (value == 1) {

      setSpinner(true);
      let apiUrl = `${process.env.REACT_APP_API_URL}/EducationDetails/getEducationDetailsListById`;
      if (type === 'Therapist') {
        apiUrl += `?therapistId=${patientId}`;
      } else {
        apiUrl += `?supervisorId=${patientId}`;
      }
      axios
        .get(apiUrl, { headers })
        .then(response => {
          setSpinner(false);
          setRows(response);
        })
        .catch(error => {
          setSpinner(false);
          console.error('Error fetching data:', error);
        });
    }
  }, [value, Education]);
  const [TemplatesSpinner, setTemplatesSpinner] = React.useState(false);
  const [Template, setTemplate] = React.useState(false);
  const [TemplateRows, setTemplateRows] = React.useState(null);
  const handleOpenTemplate = () => setTemplate(true);
  const handleCloseTemplate = () => {
    setTemplate(false)
    setValue('name', '');
    setValue('content', '');
  };
  useEffect(() => {
    if (value == 3) {
      setTemplatesSpinner(true)
      axios
        .get(`${process.env.REACT_APP_API_URL}/Template/GetAllTemplate `, { headers })
        .then(response => {
          setTemplatesSpinner(false)
          setTemplateRows(response)
        })
        .catch(error => {
          console.error('Error fetching data:', error);
          setTemplatesSpinner(false)
        });
    }
  }, [value, refresh]);
  const [modalOpenTemplate, setModalOpenTemplate] = useState(false);
  const [TemplateId, setTemplateId] = useState(false);

  const handleOpenModalTemplate = (therapistId) => {
    setModalOpenTemplate(true);
    setTemplateId(therapistId)
  };

  const [TemplateContent, setTemplateContent] = useState(null);
  const [Therapistsss, setTherapistsss] = useState(null);
  const [templateData, setTemplateData] = useState(null);

  const handleCloseModalTemplate = () => {
    setModalOpenTemplate(false);
    setSelectedRows([])
    setValue(null);
    setTemplateContent(null);
    setTherapistsss(null);
    setTemplateData(null)
    setSuperviseeSign('')
  };
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    height: 500, // Set fixed height
    maxHeight: "90vh", // Ensures it doesn’t go beyond viewport height
    bgcolor: "#3A6A57",
    borderRadius: "10px",
    boxShadow: 24,
    p: 3,
    border: "2px solid #C2A27C",
    zindex: 999,
    overflowY: "auto", // Enables vertical scroll if content overflows
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#C2A27C",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#3A6A57",
      borderRadius: "10px",
      border: "2px solid #C2A27C",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#2E5544",
    },
    scrollbarColor: "#3A6A57 #C2A27C",
    scrollbarWidth: "thin",
  };
  const TemplateColumns = [
    {
      field: 'id',
      headerClassName: 'super-app-theme--header',
      headerName: 'Id',
      flex: 0.1
    },

    {
      field: 'name',
      headerClassName: 'super-app-theme--header',
      headerName: 'Template Name',
      cellClassName: 'gridCell',
      flex: 0.2,
      renderCell: cellValues => (
        <Button
          size='small'
          variant='text'
          color='info'
          onClick={() => {
            setTemplate(true);
            let rowid = cellValues.row.id;
            axios
              .get(`${process.env.REACT_APP_API_URL}/Template/GetTemplateById?id=${rowid}`, { headers })
              .then((response) => {
                fields.forEach(field => {
                  setValue(field, response[field]);
                })

              })
              .catch((error) => {
                console.error('Error fetching data:', error);
              });
          }}
        >{`${cellValues.row.name}`}</Button>
      )
    },

    {
      field: 'content',
      headerClassName: 'super-app-theme--header',
      headerName: 'Content',
      flex: 0.4
    },
    {
      field: 'send',
      headerClassName: 'super-app-theme--header',
      headerName: 'Send to Supervisee',
      flex: 0.2,
      renderCell: cellValues => (
        <Button
          sx={{
            backgroundColor: '#D2B48C', // Tan color
            color: 'white',
            fontWeight: 'bold',
            borderRadius: '8px',
            boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
            '&:hover': {
              backgroundColor: '#C19A6B',
            },
          }}
          onClick={() => {
            handleOpenModalTemplate(cellValues.row.id);
          }}
        // onClick={() => {
        //   axios
        //     .post(`${process.env.REACT_APP_API_URL}/Template/SendToSupervisee`, { id: cellValues.row.id }, { headers })
        //     .then(response => {
        //       console.log('Template sent successfully');
        //     })
        //     .catch(error => {
        //       console.error('Error sending template:', error);
        //     });
        // }}
        >Send</Button>
      )
    },
    {
      field: 'isActive',
      headerClassName: 'super-app-theme--header',
      headerName: 'Delete',
      sortable: true,
      flex: 0.2,
      renderCell: cell => (
        <DeleteIcon
          style={{
            marginRight: '5px',
            float: 'right',
            marginTop: '5px',
            color: 'red',
            cursor: 'pointer'
          }}
          onClick={cellValues => {
            confirmAlert({
              message: 'Do you want to delete the record.',
              closeOnEscape: true,
              closeOnClickOutside: true,
              overlayClassName: 'overlay-custom-class-name',
              buttons: [
                {
                  label: 'Yes',
                  onClick: () => {
                    const postData = {

                      inactive: true,
                      id: cell.row.id
                    }

                    axios
                      .post(`${process.env.REACT_APP_API_URL}/Template/AddEditTemplate`, postData, {
                        headers
                      })
                      .then(response => {
                        setRefresh(!refresh)
                        // setOpenNote(false)
                        // console.log('response.data: ', response.data)
                      })
                      .catch(error => {
                        console.error('There was an error!', error)
                      })
                  }
                },
                {
                  label: 'No'
                }
              ]
            })
          }}
        ></DeleteIcon>
      )
    }


  ]
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }], // Headings
      [{ font: [] }], // Font Family
      [{ size: ['small', false, 'large', 'huge'] }], // Font Size
      ['bold', 'italic', 'underline', 'strike'], // Basic Styles
      [{ color: [] }, { background: [] }], // Color Picker
      [{ align: [] }], // Text Alignments
      [{ list: 'ordered' }, { list: 'bullet' }], // Lists
      [{ script: 'sub' }, { script: 'super' }], // Subscript & Superscript
      ['blockquote', 'code-block'], // Code Blocks & Quotes
      [{ indent: '-1' }, { indent: '+1' }], // Indentation
      ['link', 'image', 'video'], // Links, Images, Video
      [{ direction: 'rtl' }], // Text Direction (Right to Left)
      [{ table: 'table' }], // Table Insert
      ['clean'], // Remove Formatting
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  const formats = [
    'header', 'font', 'size', 'bold', 'italic', 'underline', 'strike', 'color',
    'background', 'align', 'list', 'bullet', 'script', 'blockquote', 'code-block',
    'indent', 'link', 'image', 'video', 'table', 'direction'
  ];
  const handleEditorChange = (content) => {
    // const sanitizedContent = content.replace(/<\/?[^>]+(>|$)/g, "");
    setValue('content', content);
    setValue('templateContent', content);
    setTemplateContent(content)
  };

  const [superviseeSign, setSuperviseeSign] = useState("");
const [signDate, setSignDate] = useState("");
  const handleSupervisee = () => {
    // const formattedDate = Moment().format('MM/DD/YYYY ,HH:mm'); 
    // setValue('superviseeSign', `${UserName} ✍`);
    // setValue('signDate', formattedDate);
    const formattedDate = Moment().format('MM/DD/YYYY ,HH:mm');
    setSuperviseeSign(`${UserName} ✍`);
    setSignDate(formattedDate);
 
  };
  
  const handleSubmit1 = (data) => {
    let postData = {
      ...data,
      // id: rowId,
      supervisorId: userid
    };

    axios
      .post(`${process.env.REACT_APP_API_URL}/Template/AddEditTemplate`, postData, { headers })
      .then((response) => {
        setSubmitting && setSubmitting(false);
        setRefresh(true)
        handleCloseTemplate();

        Swal.fire({
          title: 'Success!',
          text: 'Template Added Successfully!',
          icon: 'success',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      })
      .catch((error) => {
        setSubmitting && setSubmitting(false);
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong. Please try again.',
          icon: 'error',
          showConfirmButton: true,
        });
      });
  };
  const handleSubmit2 = (data) => {
    let postData = {
      id: templateData.ut.id,
      supervisorId: templateData.ut.supervisorId,
      therapistId: templateData.ut.therapistId,
      templateId: templateData.ut.templateId,
      signDate: signDate,
      superviseeSign: superviseeSign,
      templateContent: templateData.templateContent || TemplateContent ,
      pending:true,
    };
    if (type === 'Supervisor') {
      postData = {
        ...postData,
        approve: true,
        approveDate: new Date().toISOString().split('T')[0], // Today's date in YYYY-MM-DD format
        pending: false,
        approveBy: UserName, // Ensure UserName is defined properly
      };
    }
    axios
      .post(`${process.env.REACT_APP_API_URL}/Template/AddEditUserTemplate`, postData, { headers })
      .then((response) => {
        setSubmitting && setSubmitting(false);
        setRefresh(true)
        handleCloseTemplate();

        Swal.fire({
          title: 'Success!',
          text: 'Template Added Successfully!',
          icon: 'success',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      })
      .catch((error) => {
        setSubmitting && setSubmitting(false);
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong. Please try again.',
          icon: 'error',
          showConfirmButton: true,
        });
      });
  };
  const [SuperviseeRows, setSuperviseeRows] = useState([]);

  useEffect(() => {
    setSpinner(true)
    axios
      .get(`${process.env.REACT_APP_API_URL}/SupervisorTherapist/GetThrepistListBySupervisorId?supervisorId=${userid}`, { headers })
      .then(response => {
        setSpinner(false)
        setSuperviseeRows(response)
      })
      .catch(error => { setSpinner(false) })
  }, [modalOpenTemplate])
  const [selectedRows, setSelectedRows] = useState([]);


  const handleCheckboxChange = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };
  const handleSendTemplate = () => {
    if (selectedRows.length === 0) {
      handleCloseModalTemplate();
      Swal.fire({
        icon: "warning",
        title: "No Supervisee Selected",
        text: "Please select at least one Supervisee!",
        confirmButtonColor: "#C2A27C"
      });
      return;
    }

    const postData = {
      templateId: TemplateId, // TemplateId Variable
      // therapistIds: selectedRows.map((id) => ({ therapistId: id }))
      therapistIds: selectedRows
    };

    axios
      .post(`${process.env.REACT_APP_API_URL}/Template/SendForApproval`, postData, { headers })
      .then(() => {
        handleCloseModalTemplate(); // 🔥 First Close Modal
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Template Sent to Supervisee!",
          confirmButtonColor: "#C2A27C"
        });
        setSelectedRows([]); // Clear Selected Rows after success
      })
      .catch(() => {
        handleCloseModalTemplate(); // 🔥 Close Modal on Error Too
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong, please try again!",
          confirmButtonColor: "#C2A27C"
        });
      });
  };

  const eSignatureCoulmn = [
    {
      field: 'id',
      headerClassName: 'super-app-theme--header',
      headerName: 'Id',
      flex: 0.1
    },

    {
      field: 'templateName',
      headerClassName: 'super-app-theme--header',
      headerName: 'Template Name',
      cellClassName: 'gridCell',
      flex: 0.2,
      renderCell: cellValues => (
        <Button
          size='small'
          variant='text'
          color='info'
          onClick={() => {
            setTemplate(true);
            let rowid = cellValues.row.id;
            axios
              .get(`${process.env.REACT_APP_API_URL}/Template/GetUserTemplateById?id=${rowid}`, { headers })
              .then((response) => {
                fields.forEach((field) => {
                  setValue(field, response[field]);
                })
                let data = response[0];
                setSuperviseeSign(data.ut.superviseeSign); // Set value from API
                setSignDate(data.signDate);
                if (data) {
                  setTemplateData(data)
                  setTherapistsss(data.therapistName || ""); // Correctly access therapistName
                  setTemplateContent(data.templateContent || ""); // Correctly access templateContent
                } 
              })
              .catch((error) => {
                console.error('Error fetching data:', error);
              });
          }}
        >{`${cellValues.row.templateName}`}</Button>
      )
    },

    {
      field: 'therapistName',
      headerClassName: 'super-app-theme--header',
      headerName: 'TherapistName',
      flex: 0.4
    },
    {
      field: 'approvedBy',
      headerClassName: 'super-app-theme--header',
      headerName: 'Approved By',
      flex: 0.4
    },
    {
      field: 'approveDate',
      headerClassName: 'super-app-theme--header',
      headerName: 'Approve Date',
      flex: 0.4,
      valueGetter: (params) => {
        if (!params.value) return ''; // Handle empty values
        const date = new Date(params.value);
        return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
      }
    },
    {
      field: 'isActive',
      headerClassName: 'super-app-theme--header',
      headerName: 'Delete',
      sortable: true,
      flex: 0.2,
      renderCell: cell => (
        <DeleteIcon
          style={{
            marginRight: '5px',
            float: 'right',
            marginTop: '5px',
            color: 'red',
            cursor: 'pointer'
          }}
          onClick={cellValues => {
            confirmAlert({
              message: 'Do you want to delete the record.',
              closeOnEscape: true,
              closeOnClickOutside: true,
              overlayClassName: 'overlay-custom-class-name',
              buttons: [
                {
                  label: 'Yes',
                  onClick: () => {
                    const postData = {

                      inactive: true,
                      id: cell.row.id
                    }

                    axios
                      .post(`${process.env.REACT_APP_API_URL}/Template/AddEditTemplate`, postData, {
                        headers
                      })
                      .then(response => {
                        setRefresh(!refresh)
                        // setOpenNote(false)
                        // console.log('response.data: ', response.data)
                      })
                      .catch(error => {
                        console.error('There was an error!', error)
                      })
                  }
                },
                {
                  label: 'No'
                }
              ]
            })
          }}
        ></DeleteIcon>
      )
    }


  ]
  const [eSignatureRows, seteSignatureRows] = useState(null);

  const [selectedValue, setSelectedValue] = useState('all')

  const handleChange = event => {
    const newValue = event.target.value
    setSelectedValue(newValue)
    applyRefresh(newValue)
  }
  const [TherapistId, setTherapistId] = useState('');
  const [TherapistList, setTherapistList] = useState([]);
  useEffect(() => {
    if (value == 2) {
      if (type == 'Admin') {
        axios
          .get(`${process.env.REACT_APP_API_URL}/Users/getUsers?userType=${'Therapist'}`, {
            headers
          })
          .then(response => {
            var prac = [];
            response.forEach(field => {
              prac.push({
                label: field.fullName,
                value: field.id
              });
            });
            setTherapistList(prac);
          })
          .catch(error => { });
      } else {
        axios
          .get(`${process.env.REACT_APP_API_URL}/SupervisorTherapist/GetThrepistListBySupervisorId?supervisorId=${userid}`, {
            headers
          })
          .then(response => {
            var prac = [];
            response.forEach(field => {
              prac.push({
                label: field.fullName,
                value: field.id
              });
            });
            setTherapistList(prac);
          })
          .catch(error => { });
      }
    }
  }, [value]);
  useEffect(() => {
    if (value === 2) {
      fetchTemplates();
    }
  }, [value, selectedValue]);

  const fetchTemplates = async () => {
    setSpinner(true);
    try {
      const therapistIdToUse = type === 'Supervisor' ? TherapistId : userid;
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Template/GetAllUserTemplate?requestString=${selectedValue}&TherapistId=${therapistIdToUse}`,
        { headers }
      );
      seteSignatureRows(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setSpinner(false);
    }
  };

  const handleSearch = async () => {
    await fetchTemplates();
  };

  return (
    <div className="page-content">
      <Modal open={modalOpenTemplate} onClose={handleCloseModalTemplate}>

        <Box sx={modalStyle}>

          <Grid container spacing={2} >
            <Grid item xs={12}>
              <Grid container alignItems="center" sx={{ background: "#C2A27C", borderRadius: "8px", padding: "10px" }}>
                <Grid item xs={11}>
                  <Typography variant="h6" sx={{ color: "#fff", fontWeight: "bold" }}>
                    SEND TO SUPERVISEE
                  </Typography>
                </Grid>
                <Grid item xs={1} sx={{ textAlign: "right" }}>
                  <CancelOutlinedIcon onClick={handleCloseModalTemplate} sx={{ color: "red", cursor: "pointer" }} />
                </Grid>
              </Grid>
            </Grid>
            {spinner ? (
              <Box display="flex" justifyContent="center" alignItems="center" height="50vh" width="100%">
                <CircularProgress sx={{ color: "#C2A27C" }} />
              </Box>
            ) : (
              <Box display="flex" flexDirection="column" gap={2} width="100%" p={3}>
                {SuperviseeRows.map((row, index) => (
                  <Box
                    key={index}
                    display="flex"
                    alignItems="left"
                    justifyContent="left" // Center horizontally
                    textAlign="left" // Text alignment center
                    gap={2}
                    width="78%" // Full width
                    sx={{
                      background: "#333",
                      padding: "10px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      '&:hover': { background: "#444" }
                    }}
                    onClick={() => handleCheckboxChange(row.id)}
                  >
                    <Checkbox sx={{ color: "#C2A27C" }}
                      checked={selectedRows.includes(row.id)}
                      onChange={() => handleCheckboxChange(row.id)}

                    />
                    <Typography variant="body1" sx={{ fontWeight: "bold", color: "white" }}>
                      {row.fullName}
                    </Typography>
                  </Box>
                ))}
              </Box>

            )}
            <Grid item xs={8}></Grid>
            <Grid item xs={3}>
              <Button
                variant="contained"
                fullWidth
                size='small'
                onClick={handleSendTemplate}
                sx={{
                  backgroundColor: "#C2A27C",
                  color: "#fff",
                  fontWeight: "bold",
                  boxShadow: "4px 4px 5px rgba(0, 0, 0, 0.3)",
                  "&:hover": { backgroundColor: "#A9906C" }
                }}
              >
                SEND TO SUPERVISEE
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <Container style={{ padding: '10px' }} >
        <Dialog
          open={deleteAlert}
          onClose={handleCloseModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle style={{ fontWeight: 'bolder' }} id="alert-dialog-title">{"Delete Confirmation"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" style={{ fontWeight: '200' }}>
              Do you want to delete the record?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal} variant="contained" style={{ background: '#377562' }}>
              No
            </Button>
            <Button onClick={handleDelete} variant="contained" style={{ background: '#377562' }} autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <Modal
          open={Education}
          onClose={handleCloseEducation}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Grid container>
              <Grid item xs={12} sm={12} xl={12} >
                <Headroom >
                  <Grid
                    container
                    style={{ backgroundColor: '#356F60', position: 'sticky' }}
                  >
                    <Grid item xs={12} sm={12} xl={12}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'left',
                          justifyContent: 'space-between',
                          height: '2rem'
                        }}
                      >
                        <DialogTitle
                          style={{
                            flex: 1,
                            // textAlign: 'left',
                          }}
                        >
                          <h1
                            style={{
                              fontWeight: 'bold',
                              // textAlign: 'left',
                              marginTop: '-10px',
                              color: '#fff',
                              textDecoration: 'underline',
                              fontSize: '1rem'

                            }}
                          >
                            Education Details

                          </h1>
                        </DialogTitle>
                        <CancelOutlinedIcon
                          onClick={handleCloseEducation}
                          fontSize="large"
                          color="red"
                          style={{
                            color: 'red',
                            paddingRight: '5px',
                            cursor: 'pointer',
                            float: 'right'
                            // marginLeft: 'auto',
                            // marginRight: '1.5rem'
                          }}
                        ></CancelOutlinedIcon>
                      </div>
                    </Grid>


                  </Grid>
                </Headroom>
              </Grid>
              <Grid item xs={12} sm={12} xl={12}>
                <EducationRegistration Eduid={Eduid} SEduid={userid} TEduid={userid} handleCloseEducation={handleCloseEducation} ></EducationRegistration>
              </Grid>
            </Grid>

          </Box>
        </Modal>
        <Modal
          open={Template}
          onClose={handleCloseTemplate}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style2}>
            <Grid container>
              <Grid item xs={12} sm={12} xl={12} >
                <Headroom >
                  <Grid
                    container
                    style={{ backgroundColor: '#356F60', position: 'sticky', borderRadius: '6px', padding: '4px' }}
                  >
                    <Grid item xs={12} sm={12} xl={12}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'left',
                          justifyContent: 'space-between',
                          height: '2.5rem'
                        }}
                      >
                        <DialogTitle
                          style={{
                            flex: 1,
                            // textAlign: 'left',
                          }}
                        >
                          <h1
                            style={{
                              fontWeight: 'bold',
                              // textAlign: 'left',
                              marginTop: '-10px',
                              color: '#fff',
                              textDecoration: 'underline',
                              fontSize: '1.3rem'

                            }}
                          >
                            Templates

                          </h1>
                        </DialogTitle>
                        <CancelOutlinedIcon
                          onClick={handleCloseTemplate}
                          fontSize="large"
                          color="red"
                          style={{
                            color: 'red',
                            paddingRight: '5px',
                            cursor: 'pointer',
                            float: 'right'
                            // marginLeft: 'auto',
                            // marginRight: '1.5rem'
                          }}
                        ></CancelOutlinedIcon>
                      </div>
                    </Grid>


                  </Grid>
                </Headroom>
              </Grid>
                <Grid
                  container
                  spacing={2}
                  style={{
                    padding: '20px',
                    maxHeight: 480,
                    overflowY: 'auto',
                    color: '#000',
                  }}
                >
                  {value === 3 ? (
                    <>
                      <Grid item xs={12} >
                        <InputLabel>Template Name</InputLabel>
                        <Controller
                          name="name"
                          control={control}
                          rules={{ required: 'Full Name is required' }}
                          render={({ field }) => (
                            <TextField
                              size="small"
                              placeholder="Name"
                              {...field}
                              fullWidth
                              error={!!errors.name}
                              helperText={errors.name?.message}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <InputLabel>Text</InputLabel>
                        <Controller
                          name="content"
                          control={control}
                          rules={{ required: 'Text is required' }}
                          render={({ field }) => (
                            <>
                              <ReactQuill
                                {...field}
                                theme="snow"
                                modules={modules}
                                formats={formats}
                                onChange={handleEditorChange}
                                style={{
                                  backgroundColor: 'white',
                                  border: errors.text ? '1px solid red' : '1px solid #ced4da',
                                  borderRadius: '5px',
                                  minHeight: '250px',
                                  width: '900px',
                                  maxHeight: '350px',
                                  overflowY: 'auto',
                                }}
                              />
                              {errors.text && (
                                <p
                                  style={{
                                    color: 'red',
                                    fontSize: '12px',
                                    marginTop: '4px',
                                    marginLeft: '2px',
                                  }}
                                >
                                  {errors.text.message}
                                </p>
                              )}
                            </>
                          )}
                        />
                      </Grid>
                      <Grid item xs={6} style={{ marginTop: '10px' }}>
                    <Button
                      className="Button"
                      fullWidth
                      onClick={handleSubmit(handleSubmit1)}
                      style={{
                        borderRadius: '10px',
                        color: 'white',
                        height: '40px',
                        backgroundColor: '#28a745',
                        fontSize: '14px',
                        fontWeight: 'bold',
                      }}
                    >
                      Save
                    </Button>
                  </Grid>

                  <Grid item xs={6} style={{ marginTop: '10px' }}>
                    <Button
                      className="Button"
                      onClick={handleCloseTemplate}
                      fullWidth
                      style={{
                        borderRadius: '10px',
                        color: 'white',
                        height: '40px',
                        backgroundColor: '#dc3545',
                        fontSize: '14px',
                        fontWeight: 'bold',
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                    </>
                  ) : (

                    <>
                      <Grid item xs={12} >
                        <InputLabel>Therapist Name</InputLabel>
                        <TextField
                          size="small"
                          placeholder="Therapist Name"
                          value={Therapistsss}
                          onChange={(e) => {
                            setTherapistsss(e.target.value)
                          }}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <InputLabel>Text</InputLabel>
                        <ReactQuill
                          value={TemplateContent}
                          theme="snow"
                          modules={modules}
                          formats={formats}
                          onChange={handleEditorChange}
                          style={{
                            backgroundColor: 'white',
                            border: errors.text ? '1px solid red' : '1px solid #ced4da',
                            borderRadius: '5px',
                            minHeight: '250px',
                            width: '900px',
                            maxHeight: '250px',
                            overflowY: 'auto',
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Controller
                          name="superviseeSign"
                          control={control}
                          {...register("superviseeSign")}
                          render={({ field }) =>
                            <TextField
                            value={superviseeSign}
                              size="small"
                              placeholder="Supervisee Signature..."
                              fullWidth
                              variant="standard"
                              InputProps={{
                                readOnly: true,
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={handleSupervisee}
                                      disabled={type !== 'Therapist'} 
                                    >
                                      <SignInIcon style={{ color: '#356F60' }} />

                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}

                            />
                          }
                        />

                      </Grid>
                      <Grid item xs={6} style={{ marginTop: '10px' }}>
                    <Button
                      className="Button"
                      fullWidth
                      onClick={handleSubmit(handleSubmit2)}
                      style={{
                        borderRadius: '10px',
                        color: 'white',
                        height: '40px',
                        backgroundColor: '#28a745',
                        fontSize: '14px',
                        fontWeight: 'bold',
                      }}
                    >
                      {type === 'Supervisor' ? "Approve" :"Save"}
                    </Button>
                  </Grid>

                  <Grid item xs={6} style={{ marginTop: '10px' }}>
                    <Button
                      className="Button"
                      onClick={handleCloseTemplate}
                      fullWidth
                      style={{
                        borderRadius: '10px',
                        color: 'white',
                        height: '40px',
                        backgroundColor: '#dc3545',
                        fontSize: '14px',
                        fontWeight: 'bold',
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                    </>
                  )}
                 
                </Grid>
            </Grid>

          </Box>
        </Modal>
        <Grid container spacing={1}>
          <Grid item xs={12}>

            <TabContext value={value}>
              <Box style={{ marginBottom: "20px" }}>
                <TabList
                  onChange={handleChangetab}
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="lab API tabs example"
                  TabIndicatorProps={{
                    style: {
                      display: "none", // Hide the bottom indicator
                    },
                  }}
                >
                  <Tab
                    value={0}
                    label="Uploads"
                    style={{
                      textTransform: "none",
                      fontWeight: value === 0 ? "bold" : "normal",
                      width: "20%",
                      color: "#fff",
                      backgroundColor: value === 0 ? "#a89254" : "#c4a866",
                      borderRadius: "4px 0 0 4px",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = "#b09a5a")}
                    onMouseLeave={(e) => (e.target.style.backgroundColor = value === 0 ? "#a89254" : "#c4a866")}
                  />
                  <Tab
                    value={1}
                    label="Continuing Education"
                    style={{
                      textTransform: "none",
                      fontWeight: value === 1 ? "bold" : "normal",
                      width: type == 'Therapist' ? "40%" : "30%",
                      color: "#fff",
                      backgroundColor: value === 1 ? "#695636" : "#7b6a45",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = "#6f5e3b")}
                    onMouseLeave={(e) => (e.target.style.backgroundColor = value === 1 ? "#695636" : "#7b6a45")}
                  />
                  <Tab
                    value={2}
                    label="eSignature Documents"
                    style={{
                      textTransform: "none",
                      fontWeight: value === 2 ? "bold" : "normal",
                      width: type == 'Therapist' ? "40%" : "30%",
                      color: "#fff",
                      backgroundColor: value === 2 ? "#7d9989" : "#98b2a1",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = "#89a89b")}
                    onMouseLeave={(e) => (e.target.style.backgroundColor = value === 2 ? "#7d9989" : "#98b2a1")}
                  />
                  {type !== 'Therapist' && (
                    <Tab
                      value={3}
                      label="Templates"
                      style={{
                        textTransform: "none",
                        fontWeight: value === 3 ? "bold" : "normal",
                        width: "20%",
                        color: "#fff",
                        backgroundColor: value === 3 ? "#2d5943" : "#3b6b50",
                        borderRadius: "0 4px 4px 0",
                        transition: "0.3s",
                      }}
                      onMouseEnter={(e) => (e.target.style.backgroundColor = "#357f5d")}
                      onMouseLeave={(e) => (e.target.style.backgroundColor = value === 3 ? "#2d5943" : "#3b6b50")}
                    />
                  )}
                </TabList>
              </Box>


              <TabPanel value={0}>
                <Box mb={1}>
                  <Grid container xs={12} sm={12} md={12} lg={12} style={{ width: '100%' }}>
                    <Grid item spacing={1} xs={12} sm={12} md={12} lg={12}>
                      <Button
                        className="Button"
                        sx={{ mb: 2 }}
                        onClick={handleOpenn}
                        variant='gradient'
                        color='info'
                        size='small'
                        style={{
                          width: '150px',
                          float: 'right',
                          height: '33px',
                          // backgroundColor: '#A574FD',
                          color: 'white',
                          fontSize: '14px',
                          marginRight: '15px'
                        }}
                      >
                        <AddOutlinedIcon
                          fontSize='medium'
                          style={{
                            color: 'white',
                            paddingRight: '4px',
                            paddingBottom: '2px'
                          }}
                        ></AddOutlinedIcon>
                        Add New
                      </Button>

                      <Button
                        className="Button"
                        sx={{ mb: 2, marginRight: '20px' }}
                        onClick={event => {
                          applyRefresh()
                        }}
                        style={{
                          marginBottom: '10px',
                          float: 'right',
                          marginLeft: '20px',
                          width: '150px',
                          height: '35px',
                          // backgroundColor: '#A574FD',
                          color: 'white',
                          fontSize: '14px'
                        }}
                      >
                        <CachedOutlinedIcon
                          fontSize='medium'
                          style={{
                            color: 'white',
                            marginRight: '1px',
                            paddingRight: '0px',
                            paddingBottom: '2px'
                          }}
                        ></CachedOutlinedIcon>
                        Refresh
                      </Button>
                    </Grid>
                    {spinner ? (
                      <div style={{ margin: '5rem', textAlign: 'center', width: '100%' }}>
                        <CircularProgress />
                      </div>) : (
                      <div mb={0} style={{ height: 400, width: '100%' }}>
                        {docslist === null || docslist.length === 0 ? (
                          "No Record Found"
                        ) : (
                          <DataGrid
                            rows={docslist}
                            columns={appointmentDocslist}
                            headerHeight={37}
                            sx={gridRowStyle}
                            pagination
                            autoPageSize
                          />
                        )}
                      </div>
                    )}
                  </Grid>
                </Box>
              </TabPanel>
              <TabPanel value={1}>
                <Grid container spacing={1}>

                  <Grid item xs={12} sm={12} xl={12}>
                    <Button className="Button" onClick={handleOpenEducation} variant='contained' style={{
                      fontSize: '14px', fontWeight: 'bold', float: 'right'
                    }}>
                      <AddOutlinedIcon
                        fontSize='small'
                        style={{
                          color: 'white',
                          paddingRight: '4px',
                          paddingBottom: '2px',


                        }}
                      ></AddOutlinedIcon>
                      Add New
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={12} xl={12}>
                    <Box mb={0} style={{ marginTop: 0 }}>
                      {spinner ? (
                        <div style={{ margin: '5rem', textAlign: 'center' }}>
                          <CircularProgress />
                        </div>
                      ) : (
                        <div mb={0} style={{ height: 400, width: '100%' }}>
                          {rows === null || rows.length === 0 ? ("No Record Found") : (
                            <DataGrid
                              rows={rows}
                              columns={columns}
                              headerHeight={37}
                              sx={gridRowStyle}
                              pagination
                              autoPageSize
                            />
                          )}
                        </div>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value={2}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Paper
                      elevation={4}
                      style={{
                        padding: '20px',
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        marginBottom: '16px',
                        width: '100%',
                        margin: '10px auto',
                        border: '2px solid #326C1D',
                      }}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={1}>
                          <Typography
                            style={{
                              color: 'black',
                              fontSize: '18px',
                              marginTop: '6px',
                              fontWeight: 'bold', // Make bold
                            }}
                          >
                            Type:
                          </Typography>
                        </Grid>

                        <Grid item xs={4}>
                          <NativeSelect
                            onChange={handleChange}
                            value={selectedValue}
                            style={{
                              width: '100%',
                              height: '40px',
                              padding: '5px 10px',
                              fontFamily: 'Inter',
                              fontSize: '16px',
                              fontWeight: '400',
                              borderRadius: '4px',
                              border: '1px solid #ccc',
                              outline: 'none',
                              appearance: 'none',
                              backgroundColor: 'white',
                            }}
                          >
                            <option value="all">All</option>
                            <option value="pending">Pending</option>
                            <option value="approved">Approved</option>
                          </NativeSelect>
                        </Grid>

                        {type === 'Supervisor' ? (
                          <>
                            <Grid item xs={1.3}>
                              <Typography
                                style={{
                                  color: '#333',
                                  fontSize: '18px',
                                  marginTop: '6px',
                                  fontWeight: 'bold',
                                  width: '90px',
                                }}
                              >
                                Supervisee:
                              </Typography>
                            </Grid>

                            <Grid item xs={4}>
                              <ReactSelect
                                options={TherapistList}
                                value={TherapistList.find(
                                  (option) => option.value === getValues('therapistsId')
                                )}
                                onChange={(selectedOption) => {
                                  setTherapistId(selectedOption.value);

                                }}
                                styles={{
                                  container: (base) => ({
                                    ...base,
                                    width: '100%',
                                  }),
                                  control: (base) => ({
                                    ...base,
                                    height: '40px',
                                    padding: '0px 5px',
                                    fontFamily: 'Inter',
                                    fontSize: '16px',
                                    fontWeight: '400',
                                    borderRadius: '4px',
                                    border: '1px solid #ccc',
                                    backgroundColor: 'white',
                                  }),
                                  dropdownIndicator: (base) => ({
                                    ...base,
                                    padding: '0px',
                                  }),
                                  placeholder: (base) => ({
                                    ...base,
                                    color: '#aaa',
                                  }),
                                }}
                                placeholder="Select Supervisee"
                              />
                            </Grid>
                            <Grid item xs={1.5}>
                              <Button
                                className="Button"
                                onClick={handleSearch}
                                fullWidth
                                // disabled={onFilterSearch}
                                variant='contained' style={{
                                  fontSize: '14px', fontWeight: 'bold',
                                }}
                                type="submit"
                              >
                                Search
                              </Button>
                            </Grid>
                          </>
                        ) : (
                          <Grid item xs={3}></Grid>
                        )}

                      </Grid>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} xl={12}>
                    <Box mb={0} style={{ marginTop: 0 }}>
                      {spinner ? (
                        <div style={{ margin: '5rem', textAlign: 'center' }}>
                          <CircularProgress />
                        </div>
                      ) : (
                        <div mb={0} style={{ height: 400, width: '100%' }}>
                          {eSignatureRows === null || eSignatureRows.length === 0 ? ("No Record Found") : (
                            <DataGrid
                              rows={eSignatureRows}
                              columns={eSignatureCoulmn}
                              headerHeight={37}
                              sx={gridRowStyle}
                              pagination
                              autoPageSize
                            />
                          )}
                        </div>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value={3}>
                <Grid container spacing={1}>

                  <Grid item xs={12} sm={12} xl={12}>
                    <Button className="Button" onClick={handleOpenTemplate} variant='contained' style={{
                      fontSize: '14px', fontWeight: 'bold', float: 'right'
                    }}>
                      <AddOutlinedIcon
                        fontSize='small'
                        style={{
                          color: 'white',
                          paddingRight: '4px',
                          paddingBottom: '2px',


                        }}
                      ></AddOutlinedIcon>
                      Add New
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={12} xl={12}>
                    <Box mb={0} style={{ marginTop: 0 }}>
                      {TemplatesSpinner ? (
                        <div style={{ margin: '5rem', textAlign: 'center' }}>
                          <CircularProgress />
                        </div>
                      ) : (
                        <div mb={0} style={{ height: 400, width: '100%' }}>
                          {TemplateRows === null || TemplateRows.length === 0 ? ("No Record Found") : (
                            <DataGrid
                              rows={TemplateRows}
                              columns={TemplateColumns}
                              headerHeight={37}
                              sx={gridRowStyle}
                              pagination
                              autoPageSize
                            />
                          )}
                        </div>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </TabPanel>
            </TabContext>

          </Grid>
        </Grid>

        <Modal
          aria-labelledby='transition-modal-title'
          aria-describedby='transition-modal-description'
          open={open}
          onClose={handleClose}
          closeAfterTransition
        // BackdropProps={{
        //   timeout: 500
        // }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <Grid container columnSpacing={1}>
                <Grid item xs={12}>
                  <CancelOutlinedIcon
                    onClick={handleClose}
                    fontSize='medium'
                    color='red'
                    cursor='pointer'
                    style={{ color: 'red', marginTop: '-30', float: 'right', }}
                  ></CancelOutlinedIcon>
                </Grid>
                <Grid item xs={12} style={{ fontWeight: 500, backgroundColor: '#377562', marginTop: '-15', }}>
                  <Typography style={{ fontWeight: 'bold', fontSize: '18px', color: 'white', }}>
                    Upload Document
                  </Typography>
                </Grid>
                {/* {props.callingFrom == 'Patient' ? (

                <Grid item xs={5}>
                  <Grid container>
                    <Grid item xs={4}>
                      <Typography color='black' variant='caption' fontSize='15px' fontWeight='bold'>
                        Type:
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography color='black' variant='caption' fontSize='15px'>
                        {props.type}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (null)} */}

              </Grid>
              {/* </Grid> */}
              <Grid container spacing={1}>
                <Grid item xs={5} style={{ marginTop: 15, }}>
                  <TextField
                    type='date'
                    size='small'
                    value={date}
                    onChange={e => {
                      setdate(e.target.value)
                      setDateError(false)
                    }}
                    width='auto'
                    fullWidth
                    placeholder='Select date'
                  />
                  {DateError ? <Typography style={{ color: 'red' }}>Please select date</Typography> : null}
                </Grid>
                <Grid item xs={1} style={{ marginTop: 15, }}>
                  <Typography style={{ fontSize: '14px', color: 'black', marginTop: '8px' }}>
                    Type:
                  </Typography>
                </Grid>
                <Grid item xs={6} style={{ marginTop: 15, }}>
                  <Controller
                    name='documentType'
                    margin='dense'
                    {...register('documentType')}
                    control={control}
                    render={({ field }) => (
                      <ReactSelect
                        style={{ marginTop: 0, marginBottom: 0 }}

                        {...field}
                        options={[
                          { value: 'Supervisor Agreement', label: 'Supervisor Agreement' },
                          { value: 'Jurisprudence Exam', label: 'Jurisprudence Exam' },
                          { value: 'NCE/NCMHCE Scores', label: 'NCE/NCMHCE Scores' },
                          { value: 'Transcripts', label: 'Transcripts' },
                          { value: 'Provisional License', label: 'Provisional License' },


                        ]}
                        value={{ label: getValues('documentType') }}
                        // value={type ? type : ''}
                        // onChange={e => {
                        //   setValue('type', e.target.value)
                        //   setType(e.target.value)
                        // }}

                        onChange={value => {
                          setValue('documentType', value.label)
                          setdocType(value.label)
                        }}
                        size='small'
                      />
                    )}
                  />
                </Grid>
              </Grid>

              <Grid container direction="row" alignItems="center" spacing={2} style={{ marginTop: '10px' }}>
                <Grid item xs={4}>
                  <Button className="Button" variant="contained" component="label">
                    Upload
                    <input
                      type="file"
                      name="file"
                      onInput={e => handleChangeforfile(e.target.files)}
                      style={{ display: 'none' }}
                      multiple
                    />
                  </Button>
                </Grid>
                <Grid item XS={2}>
                  <input
                    type="checkbox"
                    {...register("checkvisibel")}
                    style={{
                      marginLeft: "10px",
                      transform: "scale(1.0)",
                      marginRight: "5px",
                      marginTop: '5px',
                      fontWeight: 'bold'
                    }}
                  />
                  <label style={{ fontSize: '14px', color: 'black', marginTop: '8px' }}>
                    Visible to Supervisee
                  </label>
                </Grid>
              </Grid>
              <Grid item xs={12} style={{ marginTop: 15, }}>
                <FileUploader multiple={true} handleChange={handleChangeforfile} name='file' />
              </Grid>
              <Grid item xs={12} style={{ marginTop: '5px' }}>
                <Typography> To Upload files Please click on upload button and then Save it</Typography>
              </Grid>
              <Grid item xs={12} style={{ marginTop: '5px' }}>
                <>
                  {filename.length > 0 && (
                    <div>
                      <h2>Uploaded Files:</h2>
                      <div style={{ height: '100px', width: '100%', }}>
                        <ul>
                          {filename.map((name, index) => (
                            <>
                              {/* <li key={name}>{name} </li> */}
                              <li>
                                <Typography key={index} variant='body1' color='black'>
                                  {name} {savedFiles.includes(index) && '✓'}
                                </Typography>
                              </li>
                            </>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </>
              </Grid>
              <Grid item xs={12} style={{ marginTop: '5px' }}>
                {file && <p>Currently uploading: {file.name}</p>}
              </Grid>
              <Grid>
                {docError ? <Typography style={{ color: 'red' }}>Please select document and date</Typography> : null}
              </Grid>
              <Grid item style={{ fontWeight: 500, width: 250 }}>
                {submitting ? (
                  <Grid>
                    {/* <LoadingButton loading loadingIndicator='Saving…' color='primary' variant='contained'>
                    Fetch data
                  </LoadingButton> */}

                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <CircularProgress />
                    </Box>

                    <Typography variant='bold' component='div' color='#ba000d'>
                      Please wait your data is being saved..
                    </Typography>
                  </Grid>
                ) : (
                  <Button className="Button" variant='contained' color='primary' onClick={handleSubmit(onSubmit)} disabled={submitting} style={{ width: '80px' }}>
                    Save
                  </Button>
                )}

                <Button
                  className="Button"
                  variant='contained'
                  style={{ backgroundColor: 'primary', color: 'white', marginLeft: 10, width: '80px' }}
                  onClick={handleClose}
                >
                  Close
                </Button>
              </Grid>
            </Box>
          </Fade>
        </Modal>
        <Modal
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
          onClose={handleClose}
          open={opendocs}
        >
          <Box sx={styleofmodal}>
            <Grid container>
              <Grid item xs={9}>
                <Typography id='modal-modal-title' variant='h6' component='h2' style={{ fontWeight: 500, backgroundColor: '#377562', marginBottom: 5, color: 'white' }}>
                  {FullDocName}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                {submitting ? (
                  <LoadingButton
                    loading
                    loadingIndicator='Downloading'
                    // style={{ position: 'absolute', right: '28px', bottom: '11px' }}
                    color='primary'
                    variant='contained'
                  >
                    Fetch data
                  </LoadingButton>
                ) : (
                  <Button
                    className="Button"
                    size='small'
                    startIcon={<Download />}
                    onClick={() => {
                      handleDownloadPDF(`${urldownload}`, FullDocName)
                    }}
                    variant='contained'
                    disabled={submitting}
                    style={{
                      // backgroundColor: 'primary',
                      color: 'white',
                      float: 'right'
                      // position: 'absolute',
                      // marginRight: '28px',
                      // bottom: '11px'
                    }}
                  >
                    Download
                  </Button>
                )}
              </Grid>
              <Grid item xs={1}>
                <CancelOutlinedIcon
                  onClick={handleClose}
                  fontSize='large'
                  color='red'
                  cursor='pointer'
                  style={{ color: 'red', marginBottom: 5, float: 'right', }}
                ></CancelOutlinedIcon>

              </Grid>
              {/* <Grid item xs={2}></Grid> */}

              {(DocName && DocName == 'jpg') || DocName == 'png' || DocName == 'jpeg' ? (
                <>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={8}>

                    <img
                      height='500px'
                      width='500px'
                      border='4px solid #000'
                      // frameborder='0'
                      // overflow='hidden'
                      src={`${urlFile}`}
                    // src={`https://images.unsplash.com/photo-1672394423014-e0354d75b123?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60`}
                    ></img>
                  </Grid>
                  <Grid item xs={2}></Grid>
                </>
              ) : (
                <>
                  <Grid item xs={12}>
                    <iframe
                      height='500px'
                      width='875px'
                      // frameborder='0'
                      // overflow='hidden'
                      src={`${urlFile}`}
                    // src={`https://images.unsplash.com/photo-1672394423014-e0354d75b123?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60`}
                    ></iframe>
                  </Grid>
                </>
              )}
              {/* <Grid item xs={2}></Grid> */}
              <Grid item xs={12}></Grid>
            </Grid>
          </Box>
        </Modal>
      </Container>
    </div>
  )
}
export default Documents
